<template>
  <div class="page-shell page-shell--deliver-environment">
    <section class="page-shell__content">
      <div class="page-shell__panel page-shell__tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick" class="customTabs" type="border-card">
          <el-tab-pane label="交付环境" name="env">
            <div class="page-shell__tab-pane">
              <public-table
                v-loading="Loading"
                :column="column"
                :enableSearch="true"
                :searchItems="searchItems"
                :tableData="deliveryEnvList"
                :PageInfo="listQuery"
                :onAdd="
                  () => {
                    (editEnv = {}), (addEnvShow = true);
                  }
                "
                addPerm="Deliver.Environment.Create"
                @handlePaginationChange="handleSearchList"
              >
                <template v-slot:createTime="{ row }">{{
                  row.createTime ? timetrans(row.createTime) : '-'
                }}</template>
                <template v-slot:updateTime="{ row }">{{
                  row.updateTime ? timetrans(row.updateTime) : '-'
                }}</template>
                <template v-slot:envID="{ row }">
                  <el-button
                    size="mini"
                    v-permit="'Deliver.Environment.Update'"
                    type="text"
                    @click="editEnvHandle(row)"
                    >编辑</el-button
                  >
                  <el-button
                    size="mini"
                    v-permit="'Deliver.Environment.SYNC'"
                    type="text"
                    @click="syncRegionHandle(row)"
                    >同步集群</el-button
                  >
                </template>
              </public-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="交付集群" name="region">
            <div class="page-shell__tab-pane">
              <public-table
                v-loading="Loading"
                :column="columnRegion"
                :enableSearch="true"
                :searchItems="searchItems"
                :tableData="deliveryRegionList"
                :PageInfo="dlistQuery"
                @handlePaginationChange="getDeliverRegionList"
              >
                <template v-slot:enable="{ row }">
                  <span v-if="row.enable" style="color: #13ce66">可用</span>
                  <span v-if="!row.enable" style="color: #ff4949">禁用</span>
                </template>
                <template v-slot:totalMemory="{ row }">
                  <span>{{ row.usedMemory }}/{{ row.totalMemory }}</span>
                </template>
                <template v-slot:status="{ row }">
                  <span v-if="row.status == 'ok'" style="color: #13ce66">
                    已连接
                  </span>
                  <span v-else style="color: #ff4949">失联</span>
                </template>
                <template v-slot:createTime="{ row }">{{
                  row.createTime ? timetrans(row.createTime) : '-'
                }}</template>

                <template v-slot:envID="{ row }">
                  <el-button
                    v-permit="'Deliver.Region.Update'"
                    size="mini"
                    type="text"
                    v-if="row.enable"
                    @click="changeStatus(row)"
                    >禁用</el-button
                  >
                  <el-button
                    v-permit="'Deliver.Region.Update'"
                    size="mini"
                    type="text"
                    v-if="!row.enable"
                    @click="changeStatus(row)"
                    >启用</el-button
                  >
                </template>
              </public-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </section>
    <edit-env
      v-if="addEnvShow"
      :marketID="marketID"
      :envEdit="editEnv"
      :dialogVisible="addEnvShow"
      :onSuccess="editEnvSuccess"
      :onClose="() => (addEnvShow = false)"
    ></edit-env>
  </div>
</template>
<script>
import {
  fetchDeliveryEnvList,
  fetchDeliveryRegionList,
  syncDeliveryEnvRegion,
  updateRegionStatus
} from '@/api/delivery';
import { errorHandle } from '@/utils/error';
import { timetrans } from '@/utils/validate';
import editEnv from './components/editEnv';
const defaultListQuery = {
  page: 1,
  pageSize: 10,
  total: 0
};

export default {
  name: 'EnvironmentManage',
  components: {
    'edit-env': editEnv
  },
  data() {
    return {
      timetrans,
      customerForm: {
        type: 'all'
      },
      activeName: 'env',
      searchItems: [
        {
          label: '名称',
          value: '',
          name: 'query',
          span: 10,
          type: 'input'
        }
      ],
      addEnvShow: false,
      editEnv: {},
      listQuery: defaultListQuery,
      dlistQuery: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      Loading: true,
      deliveryEnvList: [],
      deliveryRegionList: [],
      total: 1,
      column: [
        {
          prop: 'name',
          label: '名称'
        },
        {
          prop: 'url',
          label: '通信地址',
          width: '500px'
        },
        {
          prop: 'envType',
          label: '类型'
        },
        {
          prop: 'createTime',
          label: '创建时间',
          scopeStatus: true
        },
        {
          prop: 'updateTime',
          label: '更新时间',
          scopeStatus: true
        },
        {
          prop: 'envID',
          label: '操作',
          scopeStatus: true
        }
      ],
      columnRegion: [
        {
          prop: 'regionAlias',
          label: '集群名称'
        },
        {
          prop: 'envName',
          label: '交付环境名称'
        },
        {
          prop: 'totalMemory',
          label: '调度内存(MB)',
          scopeStatus: true
        },
        {
          prop: 'status',
          label: '连接状态',
          scopeStatus: true
        },
        {
          prop: 'createTime',
          label: '创建时间',
          scopeStatus: true
        },
        {
          prop: 'enable',
          label: '启用状态',
          scopeStatus: true
        },
        {
          prop: 'envID',
          label: '操作',
          scopeStatus: true
        }
      ]
    };
  },
  created() {
    this.getDeliverEnvList();
  },
  computed: {
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    }
  },

  methods: {
    handleClick(tab) {
      if (tab && tab.name === 'region') {
        this.getDeliverRegionList();
      } else {
        this.getDeliverEnvList();
      }
    },
    handleSearchList(param) {
      if (param) {
        this.listQuery = Object.assign(this.listQuery, param);
      }
      this.getDeliverEnvList();
    },
    getDeliverEnvList() {
      this.Loading = true;
      this.listQuery.marketID = this.marketID;
      fetchDeliveryEnvList(this.listQuery)
        .then((res) => {
          if (res) {
            this.deliveryEnvList = res.envs;
            this.listQuery.total = res.total;
          }
          this.Loading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.Loading = false;
        });
    },
    getDeliverRegionList(param) {
      if (param) {
        this.dlistQuery = Object.assign(this.dlistQuery, param);
      }
      this.Loading = true;
      this.dlistQuery.marketID = this.marketID;
      fetchDeliveryRegionList(this.dlistQuery)
        .then((res) => {
          if (res) {
            if (res.regions) {
              this.deliveryRegionList = res.regions;
            } else {
              this.deliveryRegionList = [];
            }
            this.dlistQuery.total = res.total;
          }
          this.Loading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.Loading = false;
        });
    },
    changeStatus(row) {
      let message = '确认要启用集群吗？启用后应用将可能交付到此集群';
      if (row.enable) {
        message = '确认要禁用集群吗？禁用后将不会使用该集群进行应用交付';
      }
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateRegionStatus({
          marketID: this.marketID,
          regionID: row.regionID,
          enable: !row.enable
        })
          .then(() => {
            this.$message.success('更新成功');
            this.getDeliverRegionList();
          })
          .catch((err) => {
            errorHandle(err);
          });
      });
    },
    editEnvSuccess() {
      this.addEnvShow = false;
      this.getDeliverEnvList();
    },
    editEnvHandle(row) {
      this.editEnv = row;
      this.addEnvShow = true;
    },
    syncRegionHandle(row) {
      syncDeliveryEnvRegion({ marketID: this.marketID, envID: row.envID })
        .then((re) => {
          this.$message.success('同步成功');
        })
        .catch((err) => {
          errorHandle(err);
        });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/page-shell.scss';
</style>



// WEBPACK FOOTER //
// src/views/deliverManage/environment/index.vue